import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const Wrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	flex: 1;	
	min-width: 400px;
	height: 400px;
    max-width: 1260px;
	box-shadow: rgb(220, 220, 220, 0.8) 0px 7px 29px 0px;
	border-radius: 20px;
    padding: 20px;
`;

export const TopInfoWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
    justify-content: center;
`;

export const Title = styled.h1`
	color: ${(props) => (props.color)};
	font-size: 40px;
	font-weight: bold;
	display: flex;
	margin-bottom: 20px;

`;

export const SubTitle = styled.h4`
	display: flex;
	gap: 4px;
	text-align: center;
	font-style: italic;
	color: ${Colors.darkBlue};
`;

export const Info = styled.span`
	font-size: 16px;
	color: ${Colors.black};
`;

export const MiddleInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 5px;
`;

export const SeparatorLine = styled.div`
	color: ${Colors.darkGray2};
	margin: 10px 0;
	border-bottom: 1px solid ${Colors.gray};
    width: 100%;
`;

export const HoverInfo = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	right: -100px;

	&:hover .your-score-info-popup {
		opacity: 1;
		visibility: visible;
		transform: translateY(4px);
	}
`;
